import { DashboardItemType } from "./dashboard-item";
import { DashboardRevenuePerMonthCompareData } from "./dashboard-revenue-per-month-compare-data";

export class DashboardPurchasePerMonthCompareData extends DashboardRevenuePerMonthCompareData {
	ToShowYears:number = 2;

	public constructor(data?:any, itemType?:DashboardItemType){
		super(data, itemType);
		let i = this.filters.findIndex(f=>f.Field == "this.TypeID");
		if (i != -1) {
			this.filters.splice(i,1);
		}
		if (!data) return;
		this.ToShowYears = parseInt(data.ToShowYears || "2");
		if (Number.isNaN(this.ToShowYears)){
			this.ToShowYears = 2;
		}
	}

	public getJSON(){
		return {
			...super.getJSON(),
			ToShowYears: `${this.ToShowYears}`
		};
	}
}